import { InfoIcon, MedalIcon } from "lucide-react";

import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "@/components/ui/popover";
import { useCompanyQuery } from "@/components/wallet/hooks/queries/use-company-query";
import { useAuth } from "@/hooks/use-auth";

export function CompanyRating() {
  const { companyId, isMaster } = useAuth();

  if (!companyId || isMaster()) {
    return null;
  }

  return <CompanyRatingInternal companyId={companyId} />;
}

export type CompanyRatingInternalProps = {
  companyId: string;
};

function CompanyRatingInternal({ companyId }: CompanyRatingInternalProps) {
  const { data: company } = useCompanyQuery(companyId);

  if (company.rating === "GOLD") {
    return (
      <div className="border rounded-lg flex items-center overflow-hidden">
        <div className="border-r h-full flex items-center p-2 bg-yellow-50 dark:bg-yellow-400/10">
          <MedalIcon className="text-yellow-500" />
        </div>

        <div className="text-sm p-2 w-full">
          <span className="text-sidebar-foreground/70 font-bold text-xs">
            Classificação da sua empresa
          </span>

          <div className="flex justify-between text-yellow-500">
            Ouro
            <Popover>
              <PopoverTrigger>
                <InfoIcon className="inline w-3 h-3" />
              </PopoverTrigger>

              <PopoverContent className="text-xs flex flex-col gap-2">
                <div className="text-justify">
                  Parabéns! Sua empresa é classificada como Ouro na Pim. Você
                  realiza entregas e paga semanalmente de forma pós-paga.
                </div>
              </PopoverContent>
            </Popover>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="border rounded-lg flex items-center overflow-hidden">
      <div className="border-r h-full flex items-center p-2">
        <MedalIcon className="text-amber-700" />
      </div>

      <div className="text-sm p-2 w-full">
        <span className="text-primary text-xs">
          Classificação da sua empresa
        </span>

        <div className="flex justify-between">
          Bronze
          <Popover>
            <PopoverTrigger>
              <InfoIcon className="inline w-3 h-3" />
            </PopoverTrigger>

            <PopoverContent className="text-xs flex flex-col gap-2">
              <div className="text-justify">
                Empresas que realizam menos de 200 entregas por mês são
                classificadas como Bronze na Pim.
              </div>

              <div className="text-justify">
                Nesse modelo, para solicitar entregas as empresas precisam antes
                realizar uma recarga de créditos, assim o valor das entregas é
                automaticamente descontado do saldo da empresa.
              </div>
            </PopoverContent>
          </Popover>
        </div>
      </div>
    </div>
  );
}
